export default "__VITE_ASSET__DR24Kj21__"